<template>
  <van-popup
    v-model:show="showDrawer"
    position="left"
    class="menu-popup"
    @click-overlay="showDrawer = false"
  >
    <div class="mask" id="scrollable-container">
      <div class="content">
        <div class="card">
          <div class="h1">
            <div class="avatar">
              <img
                :src="isLogin ? `${resBaseUrl}avatar00.jpg` : `${resBaseUrl}avatar00.jpg`"
                alt="logo"
              />
            </div>
            <div v-if="!isLogin" class="information">
              <div class="information_btn">
                <div class="login" @click="onLogin">{{ $t('userBar.login') }}</div>
                <div class="register" @click="onRegister">{{ $t('userBar.register') }}</div>
              </div>
            </div>
            <div v-else class="information">
              <div class="h1">
                <li class="li">
                  <p class="li-p-1" style="width: 1.4rem">{{ $t('menu.account') }}</p>
                  <p class="li-p-2">{{ userInfo.username }}</p>
                </li>
                <div class="ll"></div>
                <li class="li" style="width: 4rem">
                  <p class="li-p-1" style="width: 2rem">{{ $t('menu.id') }}</p>
                  <p class="li-p-2">{{ fillterLongID(userInfo.userId) }}</p>
                  <div class="copy_btn" @click="copy(userInfo.userId)">
                    <p class="copy-name"><i class="bi bi-copy"></i>{{ $t('menu.copyid') }}</p>
                  </div>
                </li>
              </div>
            </div>
          </div>
          <!-- <p class="real-money">{{ $t('menu.realmoney') }}</p> -->
          <div class="h3">
            <div class="h3-1">
              {{ isLogin ? formatMoney(balance.cash || 0) : '-- --' }}
            </div>
            <div v-if="isLogin" class="h3-2" @click="onUpdateMoney">
              <i :class="updateAnimation ? 'bi bi-arrow-repeat playAni' : 'bi bi-arrow-repeat'"></i>
              {{ balance.currencyAlias }}
            </div>
          </div>
          <div class="card-btn">
            <div class="card_btn1" @click="onDeposit">
              <i class="bi bi-wallet2"></i> {{ $t('button.deposit') }}
            </div>
            <div class="card_btn2" @click="onWithdraw">
              <i class="bi bi-cash-stack"></i> {{ $t('button.withdraw') }}
            </div>
          </div>
          <div style="height: 0.15rem" />
          <div class="card_code" @click="onBonus" v-if="hasCid">
            <p>Bonus {{ isLogin ? formatMoney(balance.bonus || 0) : '--' }}</p>
            <li><i class="bi bi-chevron-right"></i></li>
          </div>
        </div>
        <div
          v-for="(item, index) in bannersTop"
          :key="index"
          class="menu_banner"
          @click="onClickBanner(item)"
        >
          <img :src="item.cover" width="100%" />
        </div>
        <div class="submenu">
          <li
            v-for="(menu, index) in menuList"
            :key="index"
            @click="onClickMenu(menu)"
            style="margin-bottom: 0.06rem"
          >
            <i :class="`bi ${menu.icon}`"></i>{{ $t(menu.name) }}
            <i v-if="menu.id != 5" class="bi bi-chevron-right" style="float: right"></i>
            <DhLanguage v-else style="float: right; color: #ffddac" arrow="right" />
          </li>
        </div>
        <div
          v-for="(item, index) in bannersBottom"
          :key="index"
          class="menu_banner"
          @click="onClickBanner(item)"
        >
          <img :src="item.cover" width="100%" />
        </div>
        <div v-if="isLogin" class="log_out" @click="onLogout">
          <i class="bi bi-box-arrow-left"></i>{{ $t('button.logout') }}
        </div>
      </div>
    </div>
    <div class="close-continer" @click="showDrawer = false">
      <div class="close" />
    </div>
  </van-popup>
</template>
<script>
import { config } from '@/common/config.js'
import { getLocalStorage, Key } from '@/common/localStorage'
import DhLanguage from '@/components/ChangeLanguage.vue'
import { BUS, POPUP } from '@/event/EventCenter.js'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user.js'
import {
  copy,
  downloadAPK,
  encodeBase64,
  enterEnvelop,
  fillterLongID,
  formatMoney,
  savePWA
} from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import { showConfirmDialog, showSuccessToast } from 'vant'
export default {
  name: 'DhMenu',
  components: {
    DhLanguage
  },
  computed: {
    ...mapState(useUserStore, ['country', 'isLogin', 'balance', 'userInfo'])
  },
  props: {
    hasCid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDrawer: false,
      resBaseUrl: config.resBaseUrl,
      // menuList: [],
      updateAnimation: false,
      menuList: [
        {
          id: 1,
          icon: 'bi-file-text-fill',
          name: 'menu.transactions' //'Transactions'
        },
        {
          id: 2,
          icon: 'bi-clock-fill',
          name: 'menu.bettinghistory' //'Betting history'
        },
        {
          id: 3,
          icon: 'bi-headset',
          name: 'menu.customerservice' //'24 hours customer service'
        },
        {
          id: 4,
          icon: 'bi-lock-fill',
          name: 'menu.changepassword' //'Change Password'
        },
        {
          id: 5,
          icon: 'bi-translate',
          name: 'menu.language' // <i class="bi bi-translate"></i>
        }
        // {
        //   id: 6,
        //   icon: 'bi-search',
        //   name: 'menu.searchgame'
        // }
      ],
      bannersTop: [],
      bannersBottom: []
    }
  },

  mounted() {
    this.$bus.$on(BUS.SHOW_MENU, (boo) => {
      this.showDrawer = boo
    })
    // if (this.userInfo && this.userInfo.phoneNumber && this.userInfo.phoneNumber.length > 0) {
    //   this.menuList = config.menuList
    // } else {
    //   this.menuList = config.menuList.slice(1)
    // }
    this.getBannersHomeTop('menu_bar_top').then((res) => {
      this.bannersTop = res.banners

      this.getBannersHomeTop('menu_bar_bottom').then((res) => {
        this.bannersBottom = res.banners
      })
    })
    if (this.hasCid || this.country != 'ET') {
      this.menuList.unshift({
        id: 0,
        icon: 'bi-gift',
        name: 'menu.luckwheel'
      })
      this.menuList.push({
        id: 6,
        icon: 'bi-search',
        name: 'menu.searchgame'
      })
    }
    if (__APP_ENV__ != 'app' && __APP_ENV__ != 'app_staging' && this.menuList.length <= 7) {
      this.menuList.push(
        {
          id: 7,
          icon: 'bi-download',
          name: 'menu.apk'
        },
        {
          id: 8,
          icon: 'bi-floppy-fill',
          name: 'menu.pwa'
        }
      )
    }
  },

  methods: {
    formatMoney,
    fillterLongID,
    copy,
    ...mapActions(useUserStore, {
      updateUserInfo: 'updateUserInfo',
      logout: 'logout',
      checkBindViaUser: 'checkBindViaUser'
    }),
    ...mapActions(useLobbyStore, {
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame'
    }),
    onUpdateMoney() {
      if (!this.updateAnimation) {
        this.updateAnimation = true
        setTimeout(() => {
          this.updateUserInfo()
          this.updateAnimation = false
          showSuccessToast({
            message: this.$t('message.updatesucess'),
            wordBreak: 'break-word',
            duration: 3000
          })
        }, 5000)
      }
    },
    onLogin() {
      this.showDrawer = false
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'menu', to: POPUP.LOGIN, show: true })
    },
    onRegister() {
      this.showDrawer = false
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'menu', to: POPUP.REGISTER, show: true })
    },
    onDeposit() {
      this.showDrawer = false
      if (this.country == 'CI') {
        this.$router.replace('/depositci')
      } else if (this.country == 'KE') {
        this.$router.replace('/depositke')
      } else if (this.country == 'TZ') {
        this.$router.replace('/deposittz')
      } else if (this.country == 'GH') {
        this.$router.replace('/depositgh')
      } else {
        this.$router.replace('/deposit')
      }
    },
    onWithdraw() {
      this.showDrawer = false
      if (this.country == 'ET') {
        this.$router.replace('/withdrawet')
      } else if (this.country == 'GH') {
        this.$router.replace('/withdrawgh')
      } else if (this.country == 'TZ') {
        this.$router.replace('/withdrawtz')
      } else {
        this.$router.replace('/withdraw')
      }
    },
    onBonus() {
      this.showDrawer = false
      if (this.isLogin) {
        this.$router.replace('/bonus')
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'bonus', to: POPUP.LOGIN, show: true })
      }
    },
    luckywheel() {
      // https://game.megalake.games
      if (this.isLogin) {
        const url =
          `${config.selfDevelopedGameDomain}/luckywheel/index.html?token=` +
          encodeBase64(getLocalStorage(Key.Token))
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
      }
    },
    onClickMenu(menu) {
      switch (menu.id) {
        case 0:
          this.showDrawer = false
          this.luckywheel()
          // const url = 'https://game.megalake.games/luckywheel/index.html?token=' + encodeBase64(getLocalStorage(Key.Token))
          // this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
          break
        case 1:
          this.showDrawer = false
          if (this.isLogin) {
            this.$router.replace('/transactions')
          } else {
            this.$bus.$emit(BUS.SHOW_POPUP, { from: 'transactions', to: POPUP.LOGIN, show: true })
          }
          break
        case 2:
          this.showDrawer = false
          if (this.isLogin) {
            this.$router.replace('/bettinghistory')
          } else {
            this.$bus.$emit(BUS.SHOW_POPUP, { from: 'bettingHitory', to: POPUP.LOGIN, show: true })
          }
          break
        case 3:
          this.showDrawer = false
          // window.open('https://t.me/+PaRU7d46Ekw4YzI0', '_blank')
          window.LiveChatWidget.call('maximize')
          break
        case 4:
          this.showDrawer = false
          if (this.isLogin) {
            this.$bus.$emit(BUS.SHOW_POPUP, {
              from: 'changepassword',
              to: POPUP.CHANGE_PASSWORD,
              show: true
            })
          } else {
            this.$bus.$emit(BUS.SHOW_POPUP, { from: 'changepassword', to: POPUP.LOGIN, show: true })
          }
          break
        case 6:
          this.showDrawer = false
          // window.open('https://t.me/+PaRU7d46Ekw4YzI0', '_blank')
          this.$router.push({ name: 'searchGame', params: { type: 0 } })
          break
        case 7:
          this.showDrawer = false
          if (this.country == 'ET' || this.country == 'KE') {
            downloadAPK(this.country)
          }
          break
        case 8:
          this.showDrawer = false
          savePWA()
          break
        default:
          // showSuccessToast({
          //   message: menu.name,
          //   wordBreak: 'break-word'
          // })
          break
      }
    },
    onLogout() {
      showConfirmDialog({
        title: this.$t('button.logout'),
        message: `<font color="#FFFFFF">${this.$t('message.logout')}</font>`,
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonText: this.$t('button.logout'),
        showCancelButton: true,
        cancelButtonColor: '#AA884A',
        closeOnClickOverlay: true,
        allowHtml: true
        // teleport:
      }).then(() => {
        this.showDrawer = false
        this.logout()
      })
    },
    onClickBanner(item) {
      if (item && item.cmd == 'game') {
        this.showDrawer = false
        if (this.isLogin) {
          this.enterGame(parseInt(item.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
        }
      } else if (item && item.cmd == 'h5') {
        window.location.href = item.cmdValue
      } else if (item && item.cmd == 'luckywheel') {
        this.showDrawer = false
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${item.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else if (item && item.cmd == 'active') {
        if (item.cmdValue == 'redenvelope') {
          enterEnvelop(this.isLogin)
        }
      }
      // console.log('onClickBanner', getFileNameFromUrl(banner.name))
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-popup {
  display: flex;
  width: 85%;
  height: 100%;
  overflow-x: hidden;
  flex-direction: row;
  background-color: rgba($color: #000000, $alpha: 0);
  // padding-top: 0.1rem;

  .mask {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 96%;
    height: 100%; //calc(100% - var(--nav-bar-height));
    background-color: black;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 2% 0 2%;
    -ms-overflow-style: none;

    /* 隐藏滚动条，但保持滚动功能（仅针对IE和Edge） */
    .content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      // height: calc(100vh + var(--nav-bar-height));
      flex-direction: column;
      background-color: black;
      padding: 2% 3% 3% 3%;

      .card {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        margin: 0 0 0.15rem 0;
        padding: 0;
        border-radius: 0.16rem;
        background: #aa884a;
        background: -moz-linear-gradient(
          130deg,
          #dfc572 0%,
          #916c38 50%,
          #825c2d 50.1%,
          #aa884a 100%
        );
        background: -webkit-linear-gradient(
          130deg,
          #dfc572 0%,
          #916c38 50%,
          #825c2d 50.1%,
          #aa884a 100%
        );
        background: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);

        .h1 {
          display: flex;
          flex-direction: row;
          padding: 3% 12% 0px 3%;

          .avatar {
            display: flex;
            justify-content: center;
            align-content: center;
            height: 1rem;
            width: 1rem;
            border: 2px solid transparent;
            border-radius: 50%;
            background: #525252;
            background-clip: padding-box, border-box;
            background-origin: padding-box, border-box;
            background-image: linear-gradient(to right, #ffecb0, #dfc572),
              linear-gradient(130deg, #ffecb0, #dfc572);
            float: left;
            overflow: hidden;
          }

          .information {
            display: flex;
            justify-content: flex-end;
            width: 4rem;
            height: 1.1rem;
            float: right;
            border-top-width: 1px;
            border-bottom-width: 1px;
            border-top-style: solid;
            border-bottom-style: solid;
            border-top-color: #dec472;
            border-bottom-color: #825c2d;
            // border-top-width: 0.34px;
            // border-bottom-width: 0.34px;
            // border-top-style: solid;
            // border-bottom-style: solid;
            // border-top-color: #dec472;
            // border-bottom-color: #aa884a;

            .information_btn {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              width: 3.64rem;

              .login {
                line-height: 0.46rem;
                color: #ffddac;
                text-align: center;
                display: block;
                width: 1.5rem;
                height: 0.46rem;
                float: left;
                border-radius: 0.25rem 0 0 0.25rem;
                border: 1px solid #ffddac;
                font-family: Roboto;
                font-weight: 400;
                font-size: 0.24rem;
              }

              .register {
                line-height: 0.5rem;
                display: block;
                color: #825c2d;
                text-align: center;
                display: block;
                width: 2rem;
                height: 0.5rem;
                float: right;
                border-radius: 0 0.25rem 0.25rem 0;
                background: #ffddac;
                font-family: Roboto;
                font-weight: 400;
                margin-left: 0.05rem;
                font-size: 0.24rem;
              }
            }

            .h1 {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              width: 3.38rem;

              .ll {
                border-top-width: 0.5px;
                border-top-style: solid;
                border-top-color: #dec472;
                width: 3.85rem;
                height: 0.5px;
              }

              .li {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 3.38rem;
                height: 0.5rem;
                font-size: 0.24rem;

                .li-p-1 {
                  display: flex;
                  color: #ffddac;
                  width: 1.08rem;
                  float: left;
                  line-height: 0.49rem;
                }

                .li-p-2 {
                  display: flex;
                  color: #fff;
                  float: left;
                  line-height: 0.49rem;
                  font-size: 0.24rem;
                }

                .copy_btn {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                  width: max-content;
                  height: 0.3rem;
                  background: rgba(255, 190, 0, 0);
                  border-radius: 15px;
                  border: 0.5px solid #ffddac;
                  margin-left: 0.3rem;
                  margin-right: 0.1rem;
                  padding: 0 0.1rem;

                  p {
                    color: #ffddac;
                    font-size: 0.17rem;
                    width: max-content;
                  }

                  i {
                    font-size: 0.18rem;
                    margin-right: 0.05rem;
                  }
                }
              }
            }
          }
        }

        .real-money {
          width: 2.8rem;
          height: 0.2rem;
          text-align: left;
          font-family: Droid Sans;
          line-height: 0.2rem;
          margin-top: 9px;
          font-size: 0.34rem;
          color: #ffddac;
          padding: 0px 6% 0px 3%;
        }

        .h3::-webkit-scrollbar {
          width: 0;
          /* 隐藏滚动条，但保持滚动功能 */
          display: none;
        }

        .h3 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 5.3rem;
          line-height: auto;
          height: auto;
          padding: 2% 3% 0px 3%;
          overflow: hidden;
          overflow-x: scroll;
          -ms-overflow-style: none;
          /* 隐藏滚动条，但保持滚动功能（仅针对IE和Edge） */

          .h3-1 {
            width: auto;
            height: auto;
            font-family: Oswald;
            font-weight: 500;
            font-size: 0.64rem;
            color: #ffddac;
            float: left;
            line-height: 0.7rem;
            text-shadow:
              1px 1px #fff,
              -1px -1px #433a2d;
          }

          .h3-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 0.24rem;
            color: #ffddac;
            float: right;
            z-index: 5;
            width: 0.6rem;
            // height: 0.5rem;
            margin-top: 0.1rem;

            i {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.44rem;
              color: #fff;
            }
          }

          .playAni {
            animation: spin 1s ease-in-out infinite;
          }
        }

        .card-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 5.18rem;
          height: auto;
          padding: 0.5rem 3% 0px 4.5%;

          .card_btn1 {
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 0.5rem;
            border-radius: 0.3rem;
            color: #825c2d;
            background-color: #ffddac;
            text-align: center;
            float: left;
            width: 2.42rem;
            height: 0.6rem;
            border: 1px solid #ffddac;
            font-family: Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            margin-right: 0.1rem;

            i {
              color: #825c2d;
              margin-right: 0.1rem;
            }
          }

          .card_btn2 {
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 0.5rem;
            border-radius: 0.3rem;
            text-align: center;
            float: right;
            width: 2.42rem;
            height: 0.6rem;
            border: 1px solid #ffddac;

            font-family: Roboto;
            font-weight: 400;
            font-size: 0.24rem;
            color: #ffddac;
            margin-left: 0.1rem;

            i {
              color: #ffddac;
              margin-right: 5px;
            }
          }
        }

        .card_code {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.8rem;
          width: 100%;
          background: #aa884a;
          background: -moz-linear-gradient(45deg, #010101 0%, #4b4b4b 80%, #4b4b4b 100%);
          background: -webkit-linear-gradient(45deg, #010101 0%, #4b4b4b 80%, #4b4b4b 100%);
          background: linear-gradient(45deg, #010101 0%, #4b4b4b 80%, #4b4b4b 100%);
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#4b4b4b", endColorstr="#010101", GradientType=1);
          float: left;
          margin: 0.2rem 0 0.3rem 0;
          line-height: 0.4rem;

          p {
            display: inline;
            margin-left: 0.2rem;
            width: auto;
            height: 21px;
            font-family: Droid Sans;
            font-weight: 400;
            font-size: 0.28rem;
            color: #ffddac;
            line-height: 21px;
            text-align: left;
          }

          li {
            display: flex;
            justify-content: center;
            align-items: center;
            background: #d5ae78;
            background: -moz-linear-gradient(45deg, #d5ae78 0%, #ffddac 100%);
            background: -webkit-linear-gradient(45deg, #d5ae78 0%, #ffddac 100%);
            background: linear-gradient(45deg, #d5ae78 0%, #ffddac 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffddac", endColorstr="#d5ae78", GradientType=1);
            text-align: center;
            display: block;
            width: 0.8rem;
            height: 0.8rem;
            float: right;
            // padding: 0.06rem 0;

            i {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.34rem;
              color: #000;
              width: 0.9rem;
              height: 0.8rem;
              // padding-top: 4px;
              // padding-left: 5px;
            }
          }
        }
      }

      .menu_banner {
        margin: 0.1rem 0;
        height: 1.21rem;
        width: 100%;
        border-radius: 0.16rem;
        overflow: hidden;
        display: block;
      }

      .submenu {
        height: auto;
        width: 100%;
        margin: 0.3rem 0 0.3rem 0.15rem;

        li {
          font-size: 0.3rem;
          line-height: 0.8rem;
          display: block;
          color: #ffddac;

          i {
            font-size: 0.3rem;
            color: #ffddac;
            margin-right: 0.1rem;
          }
        }
      }

      .log_out {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 0.5rem;
        background: rgba(201, 79, 12, 0);
        border-radius: 0.3rem;
        border: 1px solid #95a5a5;

        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.28rem;
        color: #95a5a5;
        line-height: 0.5rem;
        margin-top: 0.5rem;

        i {
          color: #95a5a5;
          margin-right: 0.1rem;
        }
      }
    }
  }

  .mask::-webkit-scrollbar {
    width: 0;
    /* 隐藏滚动条，但保持滚动功能 */
    display: none;
  }

  .close-continer {
    width: 0.7rem;
    height: 0.68rem;
    background-color: #000;
    border-radius: 0 0.15rem 0.15rem 0;
  }

  /*关闭按钮*/
  .close {
    display: block;
    width: 0.6rem;
    height: 0.06rem;
    border-radius: 0.03rem;
    background: #fff;
    transform: rotate(45deg);
    padding: 0px;
    margin-top: 0.3rem;
  }

  .close::after {
    content: '';
    display: block;
    width: 0.6rem;
    height: 0.06rem;
    border-radius: 0.03rem;
    background: #fff;
    transform: rotate(-90deg);
  }

  .close_black {
    display: block;
    width: 0.5rem;
    height: 0.05rem;
    border-radius: 0.025rem;
    background: #000;
    transform: rotate(45deg);
    margin: 0;
  }

  .close_black::after {
    content: '';
    display: block;
    width: 0.5rem;
    height: 0.05rem;
    border-radius: 0.025rem;
    background: #000;
    transform: rotate(-90deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
